<template>
  <administrative>
    
    
    <img :src="output">
    <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
      <breeze-table
        :searchable="true"
        :fields="fields"
        :items="users"
        :searchlink="route('administrative.user.search')"
        :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create User')"
        :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View User')"
      >
        <template #role="data">{{data.item.role?data.item.role.name:''}}</template>
        <template #action="data">
          <button-link
            v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit User')"
            :href="route('administrative.user.edit',data.item.id)"
          >Edit</button-link>
        </template>
      </breeze-table>
    </div>
  </administrative>
</template>

<script>
import Administrative from "@/Pages/Administrative/Administrative";
import BreezeTable from "@/Components/Table";
import ButtonLink from "@/Components/ButtonLink";

export default {
  components: {
    Administrative,
    BreezeTable,
    ButtonLink
  },
  props: ["users"],
  data() {
    return {
      fields: [
        { key: "name", label: "Name" },
        { key: "mobile", label: "Mobile" },
        { key: "email", label: "Email" },
        { key: "role", label: "Role" },
        { key: "action", label: "Action" }
      ]
    };
  }
};
</script>
